
import { defineComponent } from '@vue/runtime-core';
import Collapsible from '../components/Collapsible.vue';

export default defineComponent({
	components: {
		Collapsible
	}
})
